
// import React, { useEffect, useRef, useState } from 'react'
// import PhotoCover from '../../Theme1/Cover/PhotoCover';
// import NoPhotoCover from './NoPhotoCover';
// import './cover.css'
// import '../../Theme1/Cover/cover.css'
// const Cover = ({details,photoMode}) => {
//     const [showScrollIndicator, setShowScrollIndicator] = useState(true);
//     const [hideScrollIndicator, setHideScrollIndicator] = useState(false);

//     const autoScrollTimeout = useRef(null);
//         const hasAutoScrolled = useRef(false);
    
//         const removeIndicator = () => {
//         if (!showScrollIndicator) return;
    
//         setHideScrollIndicator(true);
    
//         setTimeout(() => {
//           setShowScrollIndicator(false);
//         }, 300);
//       };
    
    
//         const scrollDown = () => {
//         clearTimeout(autoScrollTimeout.current);
    
//         if (!hasAutoScrolled.current) {
//           hasAutoScrolled.current = true;
//         }
    
//         removeIndicator();
    
//         window.scrollBy({
//           top: 100,
//           behavior: "smooth",
//         });
//       };
    
    
//     useEffect(() => {
    
//       autoScrollTimeout.current = setTimeout(() => {
//         scrollDown();
//       }, 8000);
    
//       return () => clearTimeout(autoScrollTimeout.current);
    
//     }, []);
    
//     useEffect(() => {
    
//       const cancelAutoScroll = () => {
//         clearTimeout(autoScrollTimeout.current);
//         hasAutoScrolled.current = true;
//           removeIndicator();
//       };
    
//       window.addEventListener("wheel", cancelAutoScroll, { passive: true });
//       window.addEventListener("touchmove", cancelAutoScroll, { passive: true });
    
//       return () => {
//         window.removeEventListener("wheel", cancelAutoScroll);
//         window.removeEventListener("touchmove", cancelAutoScroll);
//       };
    
//     }, []); 
    

//     // 
//        const databaseHasPhoto = details?.bannerType === "photo";

//   const hasPhoto =
//     photoMode === "photo"
//       ? true
//       : photoMode === "no-photo"
//       ? false
//       : databaseHasPhoto;
      
//   return  hasPhoto ? (
//     <PhotoCover onScrollClick={scrollDown} details={details}  showScrollIndicator={showScrollIndicator}  hideScrollIndicator={hideScrollIndicator}  />
//   ):(
//     <NoPhotoCover onScrollClick={scrollDown}   details={details}  showScrollIndicator={showScrollIndicator}  hideScrollIndicator={hideScrollIndicator}  />
//   )
// }

// export default Cover

import React from "react";

import PhotoCover from '../../Theme1/Cover/PhotoCover';
import NoPhotoCover from './NoPhotoCover'
import CoverController from "../../common/CoverController";
import './cover.css'

const Cover = ({ details, photoMode }) => {
  return (
    <CoverController
      details={details}
      photoMode={photoMode}
      PhotoComponent={PhotoCover}
      NoPhotoComponent={NoPhotoCover}
    />
  );
};

export default Cover;